import { render, staticRenderFns } from "./KycAdmin.vue?vue&type=template&id=10f1a9c7&scoped=true&"
import script from "./KycAdmin.vue?vue&type=script&lang=js&"
export * from "./KycAdmin.vue?vue&type=script&lang=js&"
import style0 from "./KycAdmin.vue?vue&type=style&index=0&id=10f1a9c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1a9c7",
  null
  
)

export default component.exports